var newDate = require('./date');

function timestampToDate(timestamp) {
	return newDate(timestamp, 'YYYY-MM-DDTHH:mm:ss.SSS');
}

module.exports = timestampToDate;
